import type { ReactNode } from 'react';
import { clsx } from 'clsx';

type Props = { children: ReactNode; tone?: 'success' | 'info' | 'warning' | 'danger' | 'slate' };

export function Badge({ children, tone = 'slate' }: Props) {
  const tones: Record<string, string> = {
    success: 'bg-emerald-50 text-emerald-700',
    info: 'bg-sky-50 text-sky-700',
    warning: 'bg-amber-50 text-amber-700',
    danger: 'bg-rose-50 text-rose-700',
    slate: 'bg-slate-100 text-slate-700',
  };
  return <span className={clsx('badge', tones[tone])}>{children}</span>;
}
